import {Component, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {takeUntil} from 'rxjs/operators';
import {HttpService} from '@service/http/http.service';
import {endpoints} from '../../configs/endpoints/endpoint';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-routing-by-code',
    templateUrl: './routing-by-code.component.html',
    styleUrls: ['./routing-by-code.component.scss'],
    standalone: false
})
export class RoutingByCodeComponent implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute, private http: HttpService, private router: Router) {
    this.activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: { productCode?: string; modelCode?: string; categoryCode?: string}) => {
        if (params.productCode) {
          this.goToModelConfiguration(params.productCode);
        } else if (params.modelCode) {
          this.goToModelGrid(params.modelCode, params.categoryCode);
        } else {
          this.router.navigate([''], { replaceUrl: true });
        }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  private goToModelConfiguration(productCode: string): void {
    this.http.post(endpoints.product.model.academy, {
      productCode
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: {productId?: number}) => {
        if (data?.productId) {
          this.router.navigate(['model-configuration', data.productId], { replaceUrl: true });
        } else {
          this.router.navigate([''], { replaceUrl: true });
        }
      });
  }

  private goToModelGrid(modelCode: string, categoryCode?: string): void {
    this.http.post(endpoints.product.model.academy, {
      modelCode,
      categoryCode
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: {modelId?: number, categoryId?: number}) => {
        if (data?.modelId) {

          if (data?.categoryId) {
            this.router.navigate(['model-detail-grid', data.modelId, data.categoryId], { replaceUrl: true });
          }

          else {
            this.router.navigate(['model-detail-grid', data.modelId], { replaceUrl: true });

          }

        } else {
          this.router.navigate([''], { replaceUrl: true });
        }
      });
  }
}
